import { BoExternalIdentityI, BoIdentityI } from '@sh4res/bo-common/utils/identity';

function hasAuthRole(identity: unknown): identity is Record<string, unknown> {
  return typeof identity === 'object' && identity !== null && 'auth_role' in identity;
}

export function isB2bAdmin(
  identity: unknown,
): identity is { auth_role: 'b2b_admin' } & Record<string, unknown> {
  return hasAuthRole(identity) && identity.auth_role === 'b2b_admin';
}

export function isB2bDistributor(
  identity: unknown,
): identity is { auth_role: 'b2b_distributor' } & Record<string, unknown> {
  return hasAuthRole(identity) && identity.auth_role === 'b2b_distributor';
}

export function isBoExternalIdentity(
  identity: BoIdentityI | undefined,
): identity is BoExternalIdentityI {
  return hasAuthRole(identity);
}
